import {
    AngularFireAuthModule
} from '@angular/fire/auth';
import {
    AngularFireDatabaseModule
} from '@angular/fire/database';
import {
    AngularFirestoreModule
} from '@angular/fire/firestore';
import {
    AngularFireFunctionsModule,
    FunctionsRegionToken
} from '@angular/fire/functions';
import {
    AngularFireStorageModule
} from '@angular/fire/storage';
import { NgModule } from '@angular/core';
import { AngularFireModule } from '@angular/fire';


// Initialize Firebase
const firebaseConfig = {
    apiKey: 'AIzaSyC6nQvOdbkJ1CmTjX8Spv3LUgeSZVGY7IU',
    authDomain: 'brianjess-wedding.firebaseapp.com',
    databaseURL: 'https://brianjess-wedding.firebaseio.com',
    projectId: 'brianjess-wedding',
    storageBucket: 'brianjess-wedding.appspot.com',
    messagingSenderId: '653820919283'
};

@NgModule({
    imports: [
        AngularFireAuthModule,
        AngularFireDatabaseModule,
        AngularFirestoreModule,
        AngularFireStorageModule,
        AngularFireModule.initializeApp(firebaseConfig),
        AngularFireFunctionsModule,
    ],
    providers: [
        {
            provide: FunctionsRegionToken,
            useValue: 'us-central1'
        }
    ]
})
export class FirebaseModule {
    constructor() {}
}
